import { defineStore } from 'pinia';

export const useRouteStore = defineStore('routes', {
  state: () => ({
    pages: []
  }),
  getters: {
    getIndex() {
      const newrray = this.pages.map((value, index) => ({
        value,
        indexed: index
      }))

      return newrray;
    },
    getHistory() {
      const h = this.getIndex.sort((a, b) => b.indexed - a.indexed);
      const t = h.slice(0, 20);
      return t;
    }
  },
  actions: {
    goto(value) {
      this.pages.push(value);
    },
    find(value: string) {

      const results = this.pages.filter(f => (JSON.stringify(f).toLowerCase() === value.toLowerCase()));

      return results;

   },
  }
})
